import "./styles.scss"
import React, { useEffect, useState } from "react"
import clsx from "clsx"

import iconMegaphone from "assets/images/megaphone-icon.svg"
import iconClose from "assets/images/close-icon.svg"

const TopBar = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem("promo-banner-dismissed")

    if (dismissed) return

    setVisible(true)
    document.body.classList.add("promo-banner-visible")
  }, [])

  const handleClose = () => {
    setVisible(false)
    localStorage.setItem("promo-banner-dismissed", 1)
    document.body.classList.remove("promo-banner-visible")
  }

  return (
    <div className={clsx("top-bar", visible && "top-bar--visible")}>
      <div className="container">
        <div className="top-bar__row">
          <img src={iconMegaphone} />

          <p>Darmowa dostawa do 31 sierpnia!</p>

          <button onClick={handleClose}>
            <img src={iconClose} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default TopBar
